import { SelectItem } from "@heroui/react";
import { AutocompleteMultiple } from "../AutocompleteMultiple";
import { CoolHeading } from "../CoolHeading";

export function PlayerAutocomplete({
  players,
  selectedPlayers,
  setSelectedPlayers,
}: {
  players: {
    id: number;
    name: string;
  }[];
  selectedPlayers: number[];
  setSelectedPlayers: (players: number[]) => void;
}) {
  return (
    <AutocompleteMultiple
      items={players.map((p) => ({
        id: p.id.toString(),
        name: p.name,
      }))}
      className="w-full normal-case lg:w-1/2"
      label={
        <CoolHeading variant="fixed" className="mt-1 uppercase">
          Players
        </CoolHeading>
      }
      selectedKeys={selectedPlayers.map((id) => id.toString())}
      onSelectionChange={(key) => {
        setSelectedPlayers(Array.from(key).map((id) => Number(id)));
      }}
    >
      {players
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((player) => (
          <SelectItem textValue={player.name.toString()} key={player.id}>
            {player.name}
          </SelectItem>
        ))}
    </AutocompleteMultiple>
  );
}
